<template>
  <div class="app-download-page">
    <div class="page-title">{{ appTitle }}{{ isIos ? '桌面快捷方式' : 'app下载' }}</div>

    <img class="hero-title" src="/static/image/sports_and_2_title-eb044a43aca57221f5bdc248cbb1356d.png" alt="" />

    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item><img class="banner-image" src="/static/image/sports_8.png" alt="" /></van-swipe-item>
      <van-swipe-item><img class="banner-image" src="/static/image/sports_71.png" alt="" /></van-swipe-item>
      <van-swipe-item><img class="banner-image" src="/static/image/sports_aa.png" alt="" /></van-swipe-item>
      <van-swipe-item><img class="banner-image" src="/static/image/sports_and4.png" alt="" /></van-swipe-item>
    </van-swipe>

    <img class="hero-icon" src="/static/image/sports_and_1_icon-c53b51a31998cee56a723ab1dcaa4f91.png" alt="" />

    <div v-if="isIos" class="shortcut-card">
      <div class="shortcut-title">iPhone 安装方式</div>
      <div class="shortcut-desc">iOS 不再走 IPA 下载，直接用 Safari 添加到主屏幕即可。</div>
      <div class="shortcut-step">1. 用 Safari 打开当前站点</div>
      <div class="shortcut-step">2. 点击底部分享按钮</div>
      <div class="shortcut-step">3. 选择“添加到主屏幕”</div>
      <div class="shortcut-step">4. 桌面会生成独立快捷入口</div>
      <van-button class="action-button" type="info" @click="copyShortcutUrl">复制桌面快捷方式链接</van-button>
      <div class="tips-text">首次添加建议在 Safari 中完成，添加后可直接从桌面打开。</div>
    </div>

    <div v-else>
      <div class="qrcode-tips">可扫描下发二维码进行app下载</div>
      <img class="qrcode-image" :src="$store.state.appInfo.ios_download_qrcode" alt="" />
      <van-button class="action-button" type="info" @click="openDownloadCenter">立即下载</van-button>
      <div class="tips-text">需在同一网络环境下下载安装注册，请勿切换网络；若无法正常安装，请使用手机自带浏览器打开本页面</div>
    </div>

    <div class="page-space"></div>
  </div>
</template>
<script>
export default {
  name: 'app',
  computed: {
    appTitle() {
      return this.$store.state.appInfo.title || '1919c';
    },
    isIos() {
      const userAgent = window.navigator.userAgent || '';
      return /iPhone|iPad|iPod/i.test(userAgent);
    },
    shortcutUrl() {
      return this.$store.state.appInfo.h5_url || window.location.origin + window.location.pathname;
    },
  },
  methods: {
    openDownloadCenter() {
      window.location.href = '/appdown/';
    },
    copyShortcutUrl() {
      const input = document.createElement('input');
      input.value = this.shortcutUrl;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$toast.success('链接已复制，请用 Safari 打开后添加到主屏幕');
    },
  },
};
</script>
<style lang="scss" scoped>
.app-download-page {
  padding-bottom: 1.3333rem;
}

.page-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.3rem;
  font-size: 0.5rem;
  font-weight: 700;
  color: #cf866b;
}

.hero-title,
.hero-icon,
.banner-image {
  width: 100%;
}

.hero-title,
.hero-icon {
  margin-top: 0.2667rem;
}

.shortcut-card {
  width: 90%;
  margin: 0.4rem auto 0;
  padding: 0.4267rem 0.3733rem;
  border-radius: 0.24rem;
  background: linear-gradient(180deg, #1f2937 0%, #111827 100%);
  color: #fff;
  box-sizing: border-box;
}

.shortcut-title {
  font-size: 0.42rem;
  font-weight: 700;
  margin-bottom: 0.16rem;
}

.shortcut-desc,
.shortcut-step,
.qrcode-tips,
.tips-text {
  width: 90%;
  margin: 0.2rem auto 0;
  line-height: 1.6;
  color: #ccc;
  text-align: center;
}

.shortcut-step {
  text-align: left;
  color: #f3f4f6;
}

.qrcode-image {
  width: 70%;
  margin: 0 auto;
  display: block;
}

.action-button {
  width: 90%;
  margin: 0.4rem auto 0;
  display: block;
}

.page-space {
  height: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/app.vue